import { render, staticRenderFns } from "./IconOrder.vue?vue&type=template&id=5747d7e6&scoped=true"
import script from "./IconOrder.vue?vue&type=script&lang=js"
export * from "./IconOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5747d7e6",
  null
  
)

export default component.exports